import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';

import * as NotificationMessagesActions from './notification-messages.actions';
import { NotificationsApiService } from '../../../../../shared/services/src/lib/notifications/notifications-api.service';
import { Store } from '@ngrx/store';
import {
  getSelectedOrganizationInfo,
  getUser,
} from '@boma/supplier-portal/shared/state';
import { of } from 'rxjs';
import {
  selectAllNotificationMessages,
  selectLatestMessage,
} from './notification-messages.selectors';

@Injectable()
export class NotificationMessagesEffects {
  loadNotificationMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationMessagesActions.loadNotificationMessages),
      withLatestFrom(this.store.select(getSelectedOrganizationInfo)),
      concatMap(([event, org]) =>
        this.notificationsApiService
          .listNotifications(org.id, event.page, event.pageSize, {
            messageEventTypes: event.messageEventTypes,
          })
          .pipe(
            map((data) => {
              return NotificationMessagesActions.loadNotificationMessagesSuccess(
                {
                  data,
                  refresh: event.refresh,
                }
              );
            })
          )
      ),
      catchError((error) =>
        of(
          NotificationMessagesActions.loadNotificationMessagesFailure({ error })
        )
      )
    );
  });
  loadLatestMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationMessagesActions.loadNotificationMessages),
      withLatestFrom(
        this.store.select(getSelectedOrganizationInfo),
        this.store.select(selectLatestMessage)
      ),
      concatMap(([event, org, latestMessage]) =>
        this.notificationsApiService
          .listNotifications(org.id, event.page, event.pageSize, {
            messageEventTypes: event.messageEventTypes,
            from: latestMessage.createdAt,
          })
          .pipe(
            map((data) => {
              return NotificationMessagesActions.loadLatestMessagesSuccess(
                {
                  data,
                }
              );
            })
          )
      ),
      catchError((error) =>
        of(
          NotificationMessagesActions.loadLatestMessagesFailure({ error })
        )
      )
    );
  });
  addNotificationMessagesEvents = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationMessagesActions.addNotificationMessagesEvents),
      withLatestFrom(
        this.store.select(getSelectedOrganizationInfo),
        this.store.select(getUser)
      ),
      concatMap(([event, org, user]) => {
        return this.notificationsApiService
          .addEventsToMessages(org.id, user.id, event.messages)
          .pipe(
            map((data) =>
              NotificationMessagesActions.addNotificationMessagesEventsSuccess({
                payload: data,
              })
            )
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private store: Store,
    private notificationsApiService: NotificationsApiService
  ) {}
}
